import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { flowRight as compose } from 'lodash';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
// Graphql
import getRecentReservation from './getRecentReservation.graphql';
import { withQuery } from '../../../hoc/withGraphql';
import Loader from '../../Loader/Loader';
import CommonTable from '../../CommonTable/CommonTable';
import { dateFormat } from '../../../config';

import CurrencyConverter from '../../CurrencyConverter/CurrencyConverter';
import Link from '../../Link/Link';
import { formatTime } from '../../../helpers/formatting';
import cs from './../../../components/commonStyle.css';
import s from './AdminDashboard.css';
import messages from '../../../locale/jsonMessages';
import { formatLocalizedDate } from '../../../helpers/formatLocateDate';

const RecentReservation = ({ data: { loading, getRecentReservation }, isAdminUser }) => {

  const { formatMessage, locale } = useIntl();

  const thead = () => {
    const headers = [
      'reservationId',
      'confirmationCode',
      'tripDates',
      'adminListTitle',
      'subTotalLabel',
      'status',
    ];

    if (isAdminUser) {
      headers.push('details');
    }

    return headers.map((item) => ({
      data: formatMessage({ id: item })
    }));
  };

  const reservationStyle = (reservationState) => {
    let label;
    switch (reservationState) {
      case 'pending':
        label = <FormattedMessage id={'messageStatus5'} />
        break;
      case 'expired':
        label = <FormattedMessage id={'messageStatus9'} />
        break;
      case 'approved':
        label = <FormattedMessage id={'messageStatus4'} />
        break;
      case 'declined':
        label = <FormattedMessage id={'messageStatus3'} />
        break;
      case 'completed':
        label = <FormattedMessage id={'panelHeader2'} />
        break;
      case 'cancelled':
        label = <FormattedMessage id={'messageStatus11'} />
        break;
    }
    return <p>{label}</p>;
  }

  const tbody = () => {
    return !loading &&
      getRecentReservation?.reservationData?.length > 0 &&
      getRecentReservation?.reservationData?.map((item, index) => {

        const subTotal = item?.total + item?.guestServiceFee;
        const listTitle = item.listTitle || item.dynamicListTitle || item?.listData?.title || '-';
        const formattedStartTime = formatTime(item?.startTime);
        const formattedEndTime = formatTime(item?.endTime);

        const rowData = [
          { data: item.id },
          {
            data: (
              <div>
                {isAdminUser ? (
                  <Link to={"/siteadmin/viewreservation/" + item?.id + '/reservation'}>
                    {item.confirmationCode}
                  </Link>
                ) : item.confirmationCode}
              </div>
            )
          },
          {
            data: `${formatLocalizedDate(item?.checkIn, locale, dateFormat?.dayFullMonthFormat)}, ${formattedStartTime} - ${formatLocalizedDate(item?.checkOut, locale, dateFormat?.dayFullMonthFormat)}, ${formattedEndTime}`
          },
          {
            data: (
              <div>
                <a href={"/cars/" + item?.listData?.id} target="_blank">
                  {listTitle}
                </a>
              </div>
            )
          },
          {
            data: (
              <CurrencyConverter
                amount={subTotal}
                from={item.currency}
              />
            )
          },
          { data: reservationStyle(item.reservationState) }
        ];

        if (isAdminUser) {
          rowData.push({
            data: (
              <div>
                <Link to={"/siteadmin/viewreservation/" + item?.id + '/reservation'}>
                  <FormattedMessage {...messages.viewLabel} />
                </Link>
              </div>
            )
          });
        }

        return {
          id: index,
          data: rowData
        };
      });
  };
  return (
    <div>
      <div className={s.dashboardReservationTableHeader}>
        <div>
          <h3 className={cx(cs.commonContentText, cs.fontWeightBold, cs.spaceBottom1)}>{formatMessage(messages.recentReservation)}</h3>
          <p className={cx(cs.commonSmallText, cs.greyText)}><FormattedMessage {...messages.recent10Reservation} values={{ count: getRecentReservation?.reservationData?.length }} /></p>
        </div>
        {isAdminUser && <Link to={"/siteadmin/reservations"} className={cs.commonMediumText} >
          <FormattedMessage  {...messages.viewAllReservation} />
        </Link>}
      </div>
      <CommonTable
        thead={thead}
        tbody={tbody}
        className='dashboardReservationTable'
        isHeadingHide
      />
      {loading && <Loader type="text" />}
    </div>
  );
};

export default compose(
  withStyles(cs, s),
  withQuery(getRecentReservation, {
    name: 'data',
    options: { ssr: false },
  })
)(RecentReservation);